var map = {
	"./avatar.webp": 29644,
	"./default.webp": 60129,
	"./footerLogo.webp": 70183,
	"./headerLogo.webp": 19298,
	"./logo-1.webp": 81721,
	"./placeholder-short.webp": 20184,
	"./placeholder-wide.webp": 52501,
	"./placeholder.webp": 51119,
	"./s24.webp": 6893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23214;